import { cn } from "../utils";
import type { HTMLAttributes, ReactNode } from "react";

interface TypographyProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function PageTitle({ className, children, ...props }: TypographyProps) {
  return (
    <h1
      className={cn("text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight", className)}
      {...props}
    >
      {children}
    </h1>
  );
}

export function SectionTitle({ className, children, ...props }: TypographyProps) {
  return (
    <h2
      className={cn("text-3xl md:text-4xl font-bold tracking-tight", className)}
      {...props}
    >
      {children}
    </h2>
  );
}

export function SectionSubtitle({ className, children, ...props }: TypographyProps) {
  return (
    <p
      className={cn("text-lg md:text-xl text-neutral-600", className)}
      {...props}
    >
      {children}
    </p>
  );
}

export function BodyText({ className, children, ...props }: TypographyProps) {
  return (
    <p className={cn("text-base text-neutral-700 leading-relaxed", className)} {...props}>
      {children}
    </p>
  );
}

export function SmallText({ className, children, ...props }: TypographyProps) {
  return (
    <p className={cn("text-sm text-neutral-600", className)} {...props}>
      {children}
    </p>
  );
}
